import { Box, styled } from "@mui/material";

import Stack from "@rui/Stack";

export const AllParticipantsBox = styled(Box)(({ theme }) => ({
  height: "13px",
  width: "13px",
  borderRadius: "2px",
  backgroundColor: theme.palette.shades.primary[700],
}));

export const Container = styled(Stack)(({ theme }) => ({
  border: "solid 1px",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: "6px",
  backgroundColor: "white",
  padding: theme.spacing(1.5),
  minHeight: "78px",
  [theme.breakpoints.up("mobile")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));
